import { render } from "./Pager.vue?vue&type=template&id=01e5b099"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/Components/Pager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01e5b099"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01e5b099', __exports__)) {
    api.reload('01e5b099', __exports__)
  }
  
  module.hot.accept("./Pager.vue?vue&type=template&id=01e5b099", () => {
    api.rerender('01e5b099', render)
  })

}


export default __exports__